export default __webpack_public_path__ + "static/media/doctor.faf8d289.png";